import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';

// project import
import routes from './routes';
import { selectCurrentUser } from 'store/user/user.selector';

// ==============================|| ROUTING RENDER ||============================== //


export default function ThemeRoutes() {
    const user = useSelector(selectCurrentUser);
    return useRoutes(routes(user));
}
